import { render } from "./BaccaratTable.vue?vue&type=template&id=72f30048&ts=true"
import script from "./BaccaratTable.vue?vue&type=script&lang=ts"
export * from "./BaccaratTable.vue?vue&type=script&lang=ts"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__